<script>
  import { downloadSvg, downloadPng } from "svg-crowbar";
  import { CSVDownloader } from "svelte-csv";

  export let downloadData;
  export let dataSources;
</script>

<div class="download-links">
  <div class="download-link">
    <button
      on:click={() => {
        downloadSvg(
          document.querySelector("svg.chart"),
          "country_metrics_chart.svg",
          { css: "inline" }
        );
      }}>Download chart (.svg)</button
    >
  </div>
  <div class="download-link">
    <button
      on:click={() => {
        downloadPng(
          document.querySelector("svg.chart"),
          "country_metrics_chart.png",
          { css: "inline", downloadPNGOptions: { scale: 2 } }
        );
      }}>Download chart (.png)</button
    >
  </div>
  <div class="download-link">
    <CSVDownloader
      filename="world_bank_chart_data"
      data={downloadData}
      type={"button"}
    >
      Download data (.csv)
    </CSVDownloader>
  </div>
  <div class="download-link">
    <CSVDownloader
      filename="world_bank_data_sources"
      data={dataSources}
      type={"button"}
    >
      Download data sources (.csv)
    </CSVDownloader>
  </div>
</div>

<style>
  .download-links {
    display: flex;
  }
  .download-link {
    margin-right: 6px;
  }
</style>
